import type { LicenseCriteriaStatus, Organisation } from '../../types'
import { CRITERIA_STATUSES } from './helpers'
import type { CriteriaFilters } from './use-criteria-tab-state'

interface CriteriaFilterBarProps {
  filters: CriteriaFilters
  organisations: Organisation[]
}

const SELECT_CLASS =
  'px-3 py-2 border border-stone-300 dark:border-stone-600 rounded-lg bg-white dark:bg-stone-800 text-stone-900 dark:text-stone-100'

export function CriteriaFilterBar({
  filters,
  organisations,
}: CriteriaFilterBarProps): React.ReactElement {
  return (
    <div className="flex flex-wrap gap-3">
      <select
        value={filters.filterStatus}
        onChange={(event) => {
          filters.setFilterStatus(event.target.value as LicenseCriteriaStatus | '')
        }}
        className={SELECT_CLASS}
      >
        <option value="">All Statuses</option>
        {CRITERIA_STATUSES.map((status) => (
          <option key={status.value} value={status.value}>
            {status.label}
          </option>
        ))}
      </select>
      <select
        value={filters.filterOrg}
        onChange={(event) => {
          filters.setFilterOrg(event.target.value)
        }}
        className={SELECT_CLASS}
      >
        <option value="">All Organisations</option>
        {organisations.map((org) => (
          <option key={org.id} value={org.id}>
            {org.name}
          </option>
        ))}
      </select>
    </div>
  )
}
